<script>
  export default {
    name: 'FloatBar',
    props: {
      mainPrice: {
        type: String,
        required: true,
        default: ''
      },
      additionalPrice: {
        type: String,
        required: true,
        default: ''
      }
    }
  }
</script>

<template>
  <section class="float-bar">
    <b-container>
      <div class="float-bar__wrapper">
        <div class="float-bar__prices">
          <h3 class="float-bar__price">{{ mainPrice }}</h3>
          <p class="float-bar__additional">+ {{ additionalPrice }} / mês</p>
        </div>
        <div class="float-bar__buttons">
          <slot name="firstButton" />
          <slot name="secondaryButton" />
        </div>
      </div>
    </b-container>
  </section>
</template>

<style lang="scss" scoped>
  .float-bar {
    padding: 12px 0;
    background: white;
    box-shadow: 0px 0px 25px rgba(29, 99, 103, 0.1);
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;

    @media (max-width: 767px) {
      padding: 12px 0 18px;
    }

    &__wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      @media (max-width: 767px) {
        flex-direction: column;
        align-items: start;
      }
    }

    &__button {
      @media (max-width: 767px) {
        width: 100%;
      }

      &:nth-child(2) {
        @media (max-width: 767px) {
          grid-row: -1;
        }
      }

      &--no-padding {
        padding-right: 0;
        padding-left: 0;
      }
    }

    &__prices,
    &__buttons {
      display: grid;
      align-items: center;
      grid-auto-flow: column;
    }

    &__prices {
      grid-gap: 12px;
      gap: 12px;

      @media (max-width: 767px) {
        margin-bottom: 24px;
        align-items: end;
      }
    }

    &__buttons {
      grid-gap: 24px;
      gap: 24px;

      @media (max-width: 767px) {
        width: 100%;
        grid-auto-flow: row;
        grid-gap: 14px;
        gap: 14px;
      }

      // This margin-right is just because of the whatsapp button
      @media (min-width: 767px) and (max-width: 850px) {
        margin-right: 40px;
      }
      @media (min-width: 960px) and (max-width: 1100px) {
        margin-right: 50px;
      }
      @media (min-width: 1264px) and (max-width: 1400px) {
        margin-right: 60px;
      }
    }

    &__price {
      font-weight: 700;
      font-size: 32px;
      line-height: 32px;
      margin-bottom: 5px;
    }

    &__additional {
      color: #6320E9;
      font-weight: 500;
      font-family: 'Rubik', sans-serif;
      margin: 0;
      line-height: 1rem;

      @media (max-width: 767px) {
        margin-bottom: 5px;
      }
    }
  }
</style>
